import React, {useEffect, useReducer, useState} from 'react';
import {withStyles} from '@material-ui/core';
import * as Styles from './styles';

import ModalConfirmacao from '../../../../../components/Modal/ModalConfirmacao/ModalConfirmacao';
import {TextFieldSearch} from '../../../../../components/TextField';
import {ReactSelect, ReactSelectCheckbox} from '../../../../../components/Select/SelectSearch';
import CloseIcon from '../../../../../components/Icon/CloseIcon';

import {weekDays} from '../../../TransferenciaAgendamento/constants';
import {combineDayHourPairs, loadProcedimentos} from './utils/utils';
import {
    updateProcedimentosConfiguracaoHorarioAtendimento
} from '../../../../../services/ConfiguracaoHorarioAtendimentoService';
import {findAllProfissionalSaude} from '../../../../../services/ProfissionalSaudeService';
import {findConveniosByAtivo} from '../../../../../services/ConvenioService';

const ConfigProcedimentosModal = ({
  classes,
  isOpen,
  diaSemana,
  horaInicio,
  procedimentos,
  horarios,
  onClose,
  currentConfigVigente,
  solicitante,
  convenios: conveniosProp,
}) => {
  const [horariosOptions, setHorariosOptions] = useState([]);
  const [diaSemanaOptions, setDiaSemanaOptions] = useState([]);
  const [selectedProcedimentos, setSelectedProcedimentos] = useState([]);
  const [profissionalSaude, setProfissionalSaude] = useState(null);
  const [isLoading, toggleLoading] = useReducer((state) => !state, false);
  const [conveniosOptions, setConveniosOptions] = useState([]);
  const [conveniosSelecionados, setConveniosSelecionados] = useState([]);

  const handleChangeWeekDay = (selectedsDays) => {
    const updatedWeekDays = diaSemanaOptions.map((item) => ({
      ...item,
      checked: checkIsSelected(item, selectedsDays),
    }));
    setDiaSemanaOptions(updatedWeekDays);
  };

  const handleChangeHours = (selectedHours) => {
    const updatedHours = horariosOptions.map((item) => ({
      ...item,
      checked: checkIsSelected(item, selectedHours),
    }));
    setHorariosOptions(updatedHours);
  };

  const checkIsSelected = (item, list) => {
    return list.some((option) => option.value === item.value);
  };

  const loadProcedimentosOptions = async (search, _, { page }) => {
    const { sala } = currentConfigVigente;
    const { content, last } = await loadProcedimentos({
      search,
      pageNumber: page,
      profissionalSaudeId: profissionalSaude?.id,
      salaId: sala ? sala.id : null,
    });

    return {
      options: content.map((item) => ({ nome: item.nome, id: item.id })),
      hasMore: !last,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadProfissionaisSaudeOptions = async (search, _, { page }) => {
    const response = await findAllProfissionalSaude({
      pageNumber: page,
      search,
    });

    const { content, last } = response?.data?.data?.findAllProfissionalSaude;
    return {
      options: content,
      hasMore: !last,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadConvenios = async () => {
    try {
      const unidade = JSON.parse(localStorage.getItem("_immortal|unidade_logada") || "{}");
      const response = await findConveniosByAtivo(unidade?.id);
      const convenios = response?.data?.data?.convenios || [];
      setConveniosOptions(convenios.map(c => ({ value: c.id, label: c.descricao })));
    } catch (e) {
      console.error(e);
    }
  };

  const handleSelectProcedimento = (procedimento) => {
    const updatedProcedimentos = [...selectedProcedimentos, procedimento];
    setSelectedProcedimentos(updatedProcedimentos);
  };

  const handleRemoveProcedimento = (index) => {
    const updatedProcedimentos = selectedProcedimentos.filter(
      (_, i) => i !== index
    );
    setSelectedProcedimentos(updatedProcedimentos);
  };

  const handleSaveConfig = async () => {
    const selectedsDays = diaSemanaOptions.filter((item) => item.checked);
    const selectedHours = horariosOptions.filter((item) => item.checked);
    const weekDayHourPairs = combineDayHourPairs(selectedsDays, selectedHours);
    let horariosAtendimento = currentConfigVigente.horariosAtendimento || [];

    const conveniosToSave = conveniosSelecionados.map(c => ({ id: c.value }));

    weekDayHourPairs.forEach((item) => {
      const { diaSemana, horaInicio } = item;
      const indexToUpdate = horariosAtendimento.findIndex(
        (config) =>
          config.diaSemana === diaSemana && config.horaInicio === horaInicio
      );

      if (
        indexToUpdate > -1 &&
        horariosAtendimento[indexToUpdate]?.permiteAgendamento
      ) {
        horariosAtendimento[indexToUpdate].procedimentos = [
          ...selectedProcedimentos,
        ];
        horariosAtendimento[indexToUpdate].solicitante = profissionalSaude
          ? { id: profissionalSaude?.id }
          : null;
        horariosAtendimento[indexToUpdate].convenios = conveniosToSave;
      }
    });
    const newConfigVigente = {
      ...currentConfigVigente,
      horariosAtendimento,
    };
    onSaveConfig(newConfigVigente);
  };

  const onSaveConfig = async (newConfigVigente) => {
    try {
      toggleLoading();
      await updateProcedimentosConfiguracaoHorarioAtendimento(newConfigVigente);
      onClose({ isReloadingConfig: true });
      clearData();
    } catch (error) {
      console.error(error);
    } finally {
      toggleLoading();
    }
  };

  const clearData = () => {
    setSelectedProcedimentos([]);
    setProfissionalSaude(null);
    setConveniosSelecionados([]);
  };

  useEffect(() => {
    if (!isOpen) return;
    const horariosOptions = horarios?.map((item) => ({
      value: item,
      label: item,
      checked: item === horaInicio || false,
    }));
    const diasSemanaOptions = weekDays.map((item) => ({
      value: item.value,
      label: item.nome,
      checked: item.value === diaSemana || false,
    }));
    setHorariosOptions(horariosOptions || []);
    setDiaSemanaOptions(diasSemanaOptions || []);
    setSelectedProcedimentos(procedimentos || []);
    setProfissionalSaude(solicitante || null);

    if (conveniosProp?.length > 0) {
      setConveniosSelecionados(conveniosProp.map(c => ({ value: c.id, label: c.descricao })));
    } else {
      setConveniosSelecionados([]);
    }

    loadConvenios();
  }, [isOpen]);

  if (!isOpen) return null;

  const buttonsConfig = {
    labelPrimaryButton: 'Cancelar',
    handlePrimaryButton: onClose,
    disabledPrimaryButton: isLoading,
    labelSecondButton: 'Salvar',
    handleSecondButton: handleSaveConfig,
    disabledSecondButton: isLoading,
    loadingSecondButton: isLoading,
  };

  return (
    <ModalConfirmacao
      classes={{ paperAlert: classes.paperAlert }}
      open={isOpen}
      buttons={buttonsConfig}
      title='Configurações'
      idPrimaryButton='cfg-cpm-btn-can'
      idSecondButton='cfg-cpm-btn-sal'
    >
      <Styles.Container>
        <Styles.InputContainer>
          <Styles.Label>Solicitante / Responsável</Styles.Label>
          <TextFieldSearch
            id='cfg-cpm-inp-sol'
            classNotched={classes.inputRoot}
            placeholder='Solicitante / Responsável'
            withPaginate
            onChange={(e) => setProfissionalSaude(e)}
            value={profissionalSaude}
            loadOptions={loadProfissionaisSaudeOptions}
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
          />
        </Styles.InputContainer>

        <Styles.InputContainer>
          <Styles.Label>Convênios</Styles.Label>
          <ReactSelect
            id='cfg-cpm-sel-conv'
            options={conveniosOptions}
            value={conveniosSelecionados}
            onChange={(options) => setConveniosSelecionados(options || [])}
            isMulti
            isClearable
            placeholder="Todos os convênios"
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
          />
        </Styles.InputContainer>

        <Styles.InputContainer>
          <Styles.Label>Dias da Semana</Styles.Label>
          <ReactSelectCheckbox
            id='cfg-cpm-sel-dia'
            options={diaSemanaOptions}
            value={diaSemanaOptions.filter((item) => item.checked)}
            onChange={handleChangeWeekDay}
          />
        </Styles.InputContainer>

        <Styles.InputContainer>
          <Styles.Label>Horários</Styles.Label>
          <ReactSelectCheckbox
            id='cfg-cpm-sel-hor'
            options={horariosOptions}
            value={horariosOptions.filter((item) => item.checked)}
            onChange={handleChangeHours}
          />
        </Styles.InputContainer>

        <Styles.InputContainer>
          <Styles.Label>Procedimentos</Styles.Label>
          <TextFieldSearch
            id='cfg-cpm-inp-pro'
            classNotched={classes.inputRoot}
            withPaginate
            debounceTimeout={300}
            additional={{
              page: 0,
            }}
            loadOptions={loadProcedimentosOptions}
            getOptionLabel={(option) => option?.nome}
            getOptionValue={(option) => option?.id}
            onChange={handleSelectProcedimento}
            placeholder='Selecione o(s) procedimento(s)'
          />
        </Styles.InputContainer>

        <Styles.ProcedimentosContainer procedimentos={selectedProcedimentos}>
          {selectedProcedimentos.map((procedimento, index) => (
            <Styles.ProcedimentoItem key={index}>
              {procedimento?.nome}
              {
                <CloseIcon
                  id={`cfg-cpm-ico-rem-${index}`}
                  onClick={() => handleRemoveProcedimento(index)}
                  size={12}
                  color='#505050'
                />
              }
            </Styles.ProcedimentoItem>
          ))}
        </Styles.ProcedimentosContainer>
      </Styles.Container>
    </ModalConfirmacao>
  );
};

export default withStyles(Styles.styles)(ConfigProcedimentosModal);
